var map = {
	"./33_one.mp3": "1578",
	"./34_two.mp3": "4926",
	"./35_three.mp3": "cd3f",
	"./M_Brilliant.mp3": "37b7",
	"./M_Excellent.mp3": "70e0",
	"./M_Fantastic.mp3": "ee40",
	"./M_Great.mp3": "e987",
	"./M_Perfect.mp3": "8231",
	"./M_Think again.mp3": "e97b",
	"./M_Try again.mp3": "39f0",
	"./M_Very good.mp3": "e9e2",
	"./M_Well done.mp3": "1f30",
	"./M_Work harder.mp3": "5d2d",
	"./click.mp3": "d205",
	"./false.mp3": "d08b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b330";